import React from 'react';
import { AwardIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const highlights = ['6 tomos organizados por progresión', '15 días de protocolo paso a paso', "50+ recetas prácticas"];
export function SystemIntro() {
  return <section className="w-full bg-white pb-12 pt-16 sm:pb-16 sm:pt-24" aria-labelledby="sistema-title" data-id="element-204" data-mp="239f1vmyignrv">
      <div className="mx-auto max-w-4xl px-6 text-center" data-id="element-205" data-mp="2876u6i32ibwl">
        <Reveal data-id="element-206" data-mp="1bihcosvcrlb5">
          <p className="mx-auto inline-flex max-w-full items-start gap-2 rounded-2xl bg-mint-50 px-3.5 py-2 text-left text-sm font-medium text-mint-700 ring-1 ring-inset ring-mint-200 sm:items-center sm:rounded-full" data-id="element-207" data-mp="1bj0um9l069p6">
            <AwardIcon className="mt-0.5 h-4 w-4 shrink-0 sm:mt-0" aria-hidden="true" data-id="element-208" data-mp="1kh2q69lywa52" />
            <span data-id="element-209" data-mp="1pj1vhp19ph4n">El sistema más completo para el mundo hispanohablante</span>
          </p>
          <h2 id="sistema-title" className="mt-6 font-display text-3xl leading-[1.1] text-ink sm:text-5xl" data-id="element-210" data-mp="2vwrd50z8195v">
            MegaPack Salud Plena
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-ink-soft" data-id="element-211" data-mp="15inj7l2d1xbe">
            Todo listo para usar desde hoy. Sin armar nada, sin buscar más, sin adivinar qué te inflama. No es otro libro más, esto se trata de un protocolo.
          </p>
          <ul className="mx-auto mt-8 flex max-w-2xl flex-wrap justify-center gap-x-8 gap-y-3" data-id="element-212" data-mp="wge9gxex27z2">
            {highlights.map(item => <li key={item} className="text-sm font-medium text-mint-700" data-id="element-213" data-mp="rl8mdv9s2n9e">
                {item}
              </li>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}